<template>
    <div class="d-flex">
        <div class="login-bg"></div>
        <div class="login-container">
            <div class="login-container__wrapper">
                <a href="https://ivanhoe.io/" title="Go back to Ivanhoe.io">
                    <img
                        class="login-container__logo"
                        src="https://ivanhoe.io/assets/images/logo/ivanhoe.io-logo.svg"
                        alt="ivanhoe.io Logo"
                    />
                </a>
                <h1 class="login-container__title">
                    Login
                </h1>
                <p v-if="errors.length">
                    <b class="text-danger" :key="error" v-for="error in errors">{{ error }}</b>
                </p>
                <d-form class="login-form" @submit.prevent="signIn">
                    <label for="email" class="mb-1 d-block login-form__label">
                        Email
                    </label>
                    <input
                        id="email"
                        required
                        type="email"
                        placeholder="Email"
                        v-model="email"
                        class="form-control d-block w-100 login-input"
                    />
                    <label for="password" class="mb-1 mt-2 d-block login-form__label">
                        Password
                    </label>
                    <input
                        id="password"
                        required
                        type="password"
                        placeholder="Password"
                        v-model="password"
                        class="form-control d-block w-100 login-input"
                    />
                    <div class="form-checkbox mt-2">
                        <d-checkbox name="remember">Keep me logged in</d-checkbox>
                    </div>
                    <div class="d-flex d-md-block justify-content-between align-items-center mt-2">
                        <p>
                            <a :href="`${IVANHOE_URL}/sign-up`" class="login-container__link">Get started</a>
                            |
                            <router-link :to="{name: 'resetPasswordRequest'}" class="login-container__link">Forgot password</router-link>
                        </p>
                        <input value="Login" type="submit" class="btn btn--primary d-md-block w-md-100">
                    </div>
                </d-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { AuthService } from '@/main'
    import env from '@/mixins/env'
    import * as Sentry from "@sentry/browser"

    export default {
        mixins: [env],
        data() {
            return {
                email: '',
                password: '',
                errors: []
            };
        },
        methods: {
            async signIn() {
                try {
                    const signIn = await AuthService.signIn(this.email, this.password)
                    AuthService.setToken(signIn.data.signIn)
                    AuthService.setTokenTime()
                    if (this.$router.history.current.query.hasOwnProperty('redirectUrl')) {
                        window.location = this.$router.history.current.query.redirectUrl
                    } else {
                        this.$router.go()
                    }

                } catch(e) {
                    this.errors = [];
                    this.errors.push(e.networkError.result.errors[0].message);

                    if (e.networkError.result.errors[0].message !== 'User with this email or password does not exists.') {
                        Sentry.captureException(e);
                    }
                }
            }
        },
        created() {
            console.log('init..')
        }
    };
</script>
